export default __webpack_public_path__ + "static/media/Ficha_sorgo_EN.53a2200d.png";